import DateRangePicker from "components/MainPage/Filter/DateRangePicker";
import React, { useRef, useState } from "react";
import { Loader, Table } from "semantic-ui-react";
import dateUtils from "utils/dateUtils";
import Filter from "../../Filter";
import Paginator from "../../Paginator";
import {
  useControlPointsFilterList,
  usePagination,
} from "./ConrolPointsHooks";
import ControlPointsCell from "./ControlPointsCell";
import Label from "components/MainPage/Label";
import StatsCell from "./StatsCell";
import "./../RoutePage.css";

const initDate = () => {
  const start = new Date( dateUtils.formatDate(new Date()) + " 00:00:00" );
  const end = new Date( dateUtils.formatDate(new Date()) + " 00:00:00" );
  return { start, end };
};

const emptyField = "-:--:--";

const ControlPointsTable = ({ pushNotify, logout, intl, ...props }) => {
  const [range, setRange] = useState(initDate());
  const [filters, setFilters] = useState({});
  const [isFilterActive, setIsFilterActive] = useState(false);
  const isFirstLoading = useRef(true);

  const filterList = useControlPointsFilterList({ intl });

  const [
    routeList,
    tableConfig,
    timeStatistic,
    page,
    pageCount,
    loadRoutesListFromPage,
    loading,
  ] = usePagination({
    pushNotify,
    logout,
    filters,
    range,
    setIsFilterActive,
    isFirstLoading,
    intl
  });

  const renderCell = (conf, route) => {
    let date = emptyField;
    let time1 = emptyField;
    let time2 = !conf.hideSpentTime ? emptyField : "";
    let car = "";
    let point;
    for (const name of conf.pointsName) {
      if (route.departureRouteData[name]) {
        point = route.departureRouteData[name];
        break;
      }
    }

    if (point) {
      date = dateUtils.formatDate(new Date(point.registrationDate));
      time1 = dateUtils.formatTime(new Date(point.registrationDate));
      time2 = !conf.hideSpentTime ? point.spentTime ? dateUtils.getFromHours(point.spentTime).text : emptyField : "";
      car = route.departureCurrentPoint === point.pointName  ? route.carNumber : "";
    }

    return (
      <ControlPointsCell
        crashes={point?.crashHistory}
        crashReason={point?.crashReason}
        key={conf.id}
        date={date}
        time1={time1}
        time2={time2}
        carNumber={car}
        intl={intl}
      />
    );
  };

  const renderStatCell = (conf, timeStatistic) => {
    const stats = timeStatistic.find(
      (stat) => stat.pointName === conf.pointsName[0]
    );
    return stats ? (
      <StatsCell
        key={conf.id}
        min={stats.timingValues.minTime}
        avg={stats.timingValues.averageTime}
        max={stats.timingValues.maxTime}
        intl={intl}
      />
    ) : (
      <Table.Cell key={conf.id}></Table.Cell>
    );
  };

  return (
    isFirstLoading.current?
      <Loader className={"page-loader"} active inline="centered" />
    :
    <div className="control-points-table">
        <div className="topPanel">
          <div>
            <DateRangePicker value={range} onChange={setRange} />
          </div>
          <Filter
            filter={filters}
            disabled={loading}
            setFilter={(e) => {
              setFilters(e);
            }}
            filterList={filterList}
            isFilterActive={isFilterActive}
          />
        </div>
        <Table celled striped>
          <Table.Header>
            <Table.Row className="control-points-row">
              {tableConfig.map((conf) => (
                <Table.HeaderCell key={conf.id} className="cell-width">
                  {conf.headerTranslatePath}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>

          {routeList.length === 0 ? (
            <Table.Body>
              <Table.Row className="control-points-row">
                <Table.Cell colSpan={tableConfig.length}>
                  <Label
                    text={intl.formatMessage({ id: "title.recordNotFound" })}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          ) : (
            <Table.Body>
              {routeList.map((route) => (
                <Table.Row key={route.departureId} className="control-points-row">
                  {tableConfig.map((conf) => renderCell(conf, route))}
                </Table.Row>
              ))}
              <Table.Row className="control-points-row">
                {tableConfig.map((conf) => renderStatCell(conf, timeStatistic))}
              </Table.Row>
            </Table.Body>
          )}
        </Table>

        <Paginator
          pageCount={pageCount}
          page={page}
          setPage={loadRoutesListFromPage}
          disabled={loading}
        />
      </div>
  );
};

export default ControlPointsTable;
